<template>
  <div class="logcards">
    <LogCard
      v-for="log in logs"
      v-bind:key="log.objectID"
      v-bind:log="log"
    />
    <div class="mt-3">
      <b-pagination @change="changePage" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center"></b-pagination>
    </div>
  </div>
</template>

<script>
import LogCard from './LogCard.vue'
export default {
  name: 'LogCards',
  components: {
    LogCard,
  },
  props: ['logs'],
  data() {
    return {
    }
  },
  computed: {
    currentPage() {
      return this.$store.getters.currentPage
    },
    totalRows() {
      return this.$store.getters.totalRows
    },
    perPage() {
      return this.$store.getters.perPage
    }
  },
  methods: {
    changePage(page) {
      this.$store.commit('setCurrentPage', page)
    }
  },
}
</script>

<style>

</style>